
import { Component, OnInit } from '@angular/core';
import { CustomerGuideService } from '../../service/customer-guide/customer-guide.service';
import { CustomerGuide } from '../../class/customer-guide';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { config } from '../../../../../environments/config';
import { CustomerGuideJustificationService } from '../../service/customer-guide-justification/customer-guide-justification.service';
import { formatDate } from '../../../../theme/functions/formatDate.function';
@Component({
  selector: 'app-customer-guides',
  templateUrl: './customer-guides-synergo.component.html',
  styleUrls: ['./customer-guides-synergo.component.scss']
})
export class CustomerGuidesSynergoComponent implements OnInit {


  public promiseForm: Promise<any>;

  public msgs: Message[] = [];
  public customerGuides: CustomerGuide[];
  public selectCustomerGuide: CustomerGuide;
  public customerGuideID: Number = 0;
  public modNew = false;
  public modView = false;
  public openCustomerGuide = false;
  public totalRecords: number;
  public page: number;
  public per_page: number;
  public sort: string;

  public form: FormGroup;
  public form2: FormGroup;
  public form3: FormGroup;
  public form4: FormGroup;
  public listRequisitionJustification: any[];

  public form_export: FormGroup;

  public inactivationTypeOptions: any[];
  public ReportTypeExportExcelOptions: any[];

  public apiUrl = config.API_ROOT;
  public displaySidebarJustification: boolean;
  public totalRecordsCustomerGuideJustification: number;

  public modViewDialogDeactivate: boolean;
  public modExportDialog: boolean;
  // public rowPerPageOptions = [5, 10, 20];

  constructor(
    public customerGuideService: CustomerGuideService,
    public confirmationService: ConfirmationService,
    public translate: TranslateService,
    public hasPermissionService: HasPermissionService,
    public customerGuideJustificationService: CustomerGuideJustificationService,
    public router: Router,
    public fb: FormBuilder
  ) {
    this.displaySidebarJustification = false;
    this.listRequisitionJustification = [];

    this.inactivationTypeOptions = [
      { id: 0, label: '6 months or more without requisitions', value: '6 meses o más sin requisiciones' },
      { id: 1, label: 'Completion of the commercial contract', value: 'Finalización del contrato comercial' },
      { id: 2, label: 'Delinquent billing', value: 'Facturación en mora' },
      { id: 3, label: 'other', value: 'Otro' },
    ];

    this.ReportTypeExportExcelOptions = [
      { label: 'Reporte Guía de Cliente - General', value: 'Reporte Guía de Cliente - General' },
      { label: 'Reporte Guía de Cliente - Última Requisición', value: 'Reporte Guía de Cliente - Última Requisición' },
    ];
  }

  ngOnInit() {
    //this.getCustomerGuides();
    this.page = 1;
    this.per_page = 10;

    this.createForm();
    this.createForm2();
    this.createForm3();
    this.createForm4();

    this.createExport(null);
  }

  public createForm(data: any = null) {
    data = data || {
      justification: ''
    };
    this.form = this.fb.group({
      justification: new FormControl(data.justification),
    });
  }

  public createForm2(data: any = null) {
    data = data || {
      justification: ''
    };
    this.form2 = this.fb.group({
      justification: new FormControl(data.justification, Validators.compose([Validators.required, Validators.minLength(2)]))
    });
  }

  public createForm3(data: any = null) {
    data = data || {
      company_id_filter: '',
      business_id_filter: 2
    };
    this.form3 = this.fb.group({
      company_id_filter: new FormControl(data.company_id_filter),
      business_id_filter: new FormControl(data.business_id_filter)
    });
  }

  public createForm4(data: any = null) {
    data = data || {
      inactivation_type: ''
    };
    this.form4 = this.fb.group({
      inactivation_type: new FormControl(data.inactivation_type, Validators.compose([Validators.minLength(3), Validators.required]))  // 
    });
  }

  public loadCustomerGuidesLazy(event: LazyLoadEvent) {
    if (event.rows) {
      this.per_page = event.rows;
    } else {
      this.per_page = 10;
    }
    this.page = (event.first / this.per_page) + 1;
    if (event.sortOrder === -1) {
      this.sort = '-' + event.sortField;
    } else {
      this.sort = event.sortField;
    }
    this.getCustomerGuides(event.globalFilter);
  }

  createExport(data: any = null) {
    data = data || {
      report_type: '',
    };
    this.form_export = this.fb.group({
      report_type: new FormControl(data.report_type, Validators.compose([Validators.required])),
    });
  }

  showSidebarJustification(customerGuide) {
    this.selectCustomerGuide = customerGuide;
    this.displaySidebarJustification = true;
  }

  closeSidebarJustification() {
    this.form2.reset();
    this.selectCustomerGuide = undefined;
    this.displaySidebarJustification = false;
  }

  public newCustomerGuideJustification(values) {
    const param = {
      justification: values.justification,
      customer_guide_id: this.selectCustomerGuide.id
    };
    if (values && this.form.valid) {
      const promise = this.customerGuideJustificationService.newCustomerGuideJustification(this.selectCustomerGuide.id, param);

      this.promiseForm = promise.toPromise().then(
        response => {
          this.getCustomerGuideJustification(this.selectCustomerGuide.id);
          this.translate.get('saved').subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: 'success', summary: res });
          });
          // this.closeSidebarJustification();
        },
        error => {
          this.msgs = [];
          this.msgs.push({ severity: 'error', summary: 'Error' });
        }
      );
    }
  }

  getCustomerGuideJustification(id: number) {
    this.customerGuideService.infoCustomerGuide(id).toPromise().then(
      response => {
        this.selectCustomerGuide.customer_guide_justification = response.json().data[0].customer_guide_justification;
        this.form2.reset();
        if (response.json().meta.total > response.json().meta.total_filtered) {
          this.totalRecordsCustomerGuideJustification = response.json().meta.total_filtered;
        } else {
          this.totalRecordsCustomerGuideJustification = response.json().meta.total;
        }
      },
      error => {
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'error' });
      }
    );
  }

  public getCustomerGuides(query?: string, filtersReceived?: any[]) {
    const filters = [];
    if (filtersReceived) {
      filtersReceived.forEach(element => {
        if (element.value) {
          filters.push({ 'key': element.key, 'value': element.value });
        }
      });
    }
    filters.push({ 'key': 'business_id', 'value': 2 });

    this.customerGuideService.getCustomerGuide(this.page, this.per_page, this.sort, query, filters).toPromise().then(
      response => {
        this.customerGuides = response.json().data;
        if (response.json().meta.total > response.json().meta.total_filtered) {
          this.totalRecords = response.json().meta.total_filtered;
        } else {
          this.totalRecords = response.json().meta.total;
        }
      },
      error => {
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'error' });
      }
    );
  }

  public newCustomerGuide() {
    this.modNew = !this.modNew;
    this.selectCustomerGuide = null;
  }

  public savedCustomerGuide(res) {
    this.msgs = [];
    this.msgs.push(res);
    this.selectCustomerGuide = null;
    this.modNew = false;
    this.getCustomerGuides();
  }

  public cancelCustomerGuide(res) {
    this.selectCustomerGuide = null;
    this.modNew = false;
    this.modView = false;
    this.getCustomerGuides();
  }

  public edit(customerGuide: CustomerGuide) {
    this.modNew = true;
    this.selectCustomerGuide = customerGuide;
    this.getCustomerGuides();
  }

  public view(customerGuide: CustomerGuide) {
    this.openCustomerGuide = true;
    this.selectCustomerGuide = customerGuide;
    this.customerGuideID = customerGuide.id;
    this.modView = true;
  }

  public deleteDialog(customerGuide: CustomerGuide) {
    let message;
    this.translate.get('Do you want to delete?').subscribe((res: string) => {
      message = res;
    });

    let header;
    this.translate.get('Delete Confirmation').subscribe((res: string) => {
      header = res;
    });

    this.confirmationService.confirm({
      message: message,
      header: header,
      icon: 'fa fa-trash',
      accept: () => {
        this.delete(customerGuide);
      }
    });
  }

  public delete(customerGuide: CustomerGuide) {
    this.customerGuideService.deleteCustomerGuide(customerGuide.id).toPromise().then(
      response => {
        this.msgs = [];
        this.translate.get('deleted').subscribe((res: string) => {
          this.msgs = [];
          this.msgs.push({ severity: 'success', summary: res });
        });
        this.getCustomerGuides();
      },
      error => {
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'error' });
      }
    );
  }

  public updateStatusCustomerGuide(values) {
    this.selectCustomerGuide.inactivation_type = values.inactivation_type;
    this.modViewDialogDeactivate = false;

    this.putCustomerGuide(this.selectCustomerGuide);
  }

  public activeCustomerGuide(customerGuide: CustomerGuide) {
    if (customerGuide.activated) {
      customerGuide.inactive_at = null;
      this.modViewDialogDeactivate = false;
      this.putCustomerGuide(customerGuide);
      // this.router.navigateByUrl('/pages/customer-guides');
    } else {
      customerGuide.inactive_at = formatDate(new Date().toISOString());
      this.modViewDialogDeactivate = true;

      this.selectCustomerGuide = customerGuide;
      // this.showSidebarJustification(customerGuide);
    }

    // this.updateStatusCustomerGuide(customerGuide);
  }

  public putCustomerGuide(values: CustomerGuide) {
    const param = {
      'activated': values.activated,
      'inactive_at': values.inactive_at,
      'inactivation_type': values.inactivation_type,
    };

    if (values) {
      const promise = this.customerGuideService.updateCustomerGuide(values.id, param);
      this.promiseForm = promise.toPromise().then(
        response => {
          this.translate.get('saved').subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: 'success', summary: res });
          });
        },
        error => {
          this.msgs.push({ severity: 'error', summary: 'Error' });
        }
      );
    }
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  public filter(values) {
    const filters = [];
    if (values.company_id_filter) {
      filters.push({ 'key': 'company_id-lk', 'value': values.company_id_filter.id });
    }
    this.getCustomerGuides(undefined, filters);
  }

  public gotoProfileSurvey(id) {
    this.router.navigate(['/pages/profile-surveis'], { queryParams: { id_customer_guide: id } });
  }

  public gotoRequisition(id, id_company) {
    this.router.navigate(['/pages/selection/requisitions'], { queryParams: { id_customer_guide: id, id_company: id_company } });
  }

  public gotoGestionSac(id) {
    this.router.navigate(['/pages/service-client/gestionSACs'], { queryParams: { id_company: id } });
  }

  public exportExcel(values) {
    window.open(this.apiUrl + '/customer-guides/excel?token=' + localStorage.getItem('token') + '&type=' + values.report_type.value, '_blank');
  }

  public showExportDialog() {
    this.modExportDialog = true;
  }

  public cancelExport() {
    this.modExportDialog = false;
  }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/customer-guides-synergo/customer-guides-synergo.component.ts